'use client';

import { useNinetailed } from '@ninetailed/experience.js-react';
import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { LeadGenerationInteractionProps, TrackingFunction } from '../types';
import { validateLeadGenerationEventData } from '../validation';

export const useLeadGenerationInteraction = (
  props: LeadGenerationInteractionProps,
  autoTrack: boolean = false,
): TrackingFunction => {
  const ninetailed = useNinetailed();
  const trackGtm = useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.LEAD_GENERATION_INTERACTION,
      properties: props,
    },
    autoTrack,
  );

  const track = (eventProperties: Record<string, unknown> = {}, callback?: () => void) => {
    validateLeadGenerationEventData({ ...props, ...eventProperties });
    ninetailed.track(props.interaction_type);
    trackGtm(eventProperties, callback);
  };

  return track;
};
